export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		MODERATOR: 2,
		CLIENT: 3,
		CLIENT_MODERATOR: 4,
		DRIVER: 5,
	},
	PER_PAGE: 30,
	USER: {
		VERIFIED: {
			PENDING: 0,
			IN_PROCESS: 1,
			VERIFIED: 2,
			REJECTED: 3
		},
		STATUS: {
			ACTIVE: 1,
			INACTIVE: 0
		},
		USER_TYPE: {
			NATURAL: 1,
			COMPANY: 2
		}
	},
	DOCUMENT_TYPES: {
		ID: 1,
		RIF: 2,
		PHOTO: 3,
		INCORPORATION: 4,
		MEDICAL_CERTIFICATE: 5,
		FOOD_HANDLING: 6,
		LICENSE: 7
	},
	NATIONALITIES: {
		V: 1,
		E: 2,
		J: 3,
		G: 4
	},
	ASSISTANT_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	ASSISTANT_FILES: {
		PHOTO: 1,
		ID: 2,
		MEDICAL_CERTIFICATE: 3,
		FOOD_HANDLING: 4
	},
	PAYMENT_METHODS: {
		PAYMENT_MOBILE: 1,
		TRANSFER: 2,
		ZELLE: 3,
		BITCOIN: 4,
		WALLY: 5,
		BINANCE: 6
	},
	DRIVER_OWNER: {
		YES: 1,
		NO: 0
	},
	VEHICLE_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	VEHICLE_FILES: {
		PHOTO_FRONT: 1,
		PHOTO_BACK: 2,
		PHOTO_LEFT: 3,
		PHOTO_RIGHT: 4,
		INSURANCE_POLICY: 5,
		HEALTH_REGISTRATION: 6,
		VEHICLE_CARD: 7,
		ROTC: 8,
		INSOPESCA: 9,
		RACDA: 10,
		RESQUIMC: 11,
		PLATE: 12,
		PURCHASE_TITLE: 13
	},
	PHONEPREFIX: {
		VE: 1
	},
	BRAVEALO_DOCUMENT_TYPES: {
		ID: 1,
		VEHICLE_CARD: 3,
		DRIVER_LICENSE: 5,
		RIF: 6,
		RACDA: 8,
		ROCT: 9,
		INSOPESCA: 10,
		RCV: 11,
		HEALTH_PERMIT: 12,
		RESQUIMC: 13,
		PLATE: 14,
		HEALTH_CERTIFICATE: 15,
    	FOOD_HANDLING: 16
	},
	ACCESSORY_TYPES: {
	  TIRES_CONDITION: 1,
	  PROTECTION_AND_TIE_DOWN: 2,
	  LOADING_EQUIPMENT: 3,
	  SPECIALIZED_DEVICES: 4,
	  PERSONAL_PROTECTION: 5,
	  ROADSIDE_ASSISTANCE: 6,
	  VEHICLE_CONDITION: 7,
	}
}